
import { REACT_APP_BASE_URL  } from "../Config/config";
const usersrole = JSON.parse(localStorage.getItem("@users"));


export const GetMethod = async (item) => {
  const REACT_APP_Access_Token = localStorage.getItem("@accesstoken");
  try {
    const response = await fetch(REACT_APP_BASE_URL + item.url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": REACT_APP_Access_Token,
      },
    });
    const json = await response.json();
    if (json.status == false) {
      if (json.message == "Unauthorized!") {
        LogoutUser();
      }
    }
    return json;
  } catch (Error) {
    console.log("Error api error", Error, item.url);
    return false;
  }
};
export const PostMethod = async (item) => {
  const REACT_APP_Access_Token = localStorage.getItem("@accesstoken");
  try {
    let token = REACT_APP_Access_Token;
    if (item.accesstoken) {
      token = item.accesstoken;
    }
    const response = await fetch(REACT_APP_BASE_URL + item.url, {
      method: item.method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": token, //item.authtoken,
      },
      body: JSON.stringify(item.params),
    });
    const json = await response.json();
    if (json.status == false) {
      if (json.message == "Unauthorized!") {
        LogoutUser();
      }
    }
    return json;
  } catch (error) {
    return false;
  }
};
export const LogoutUser = async () => {
  try {
    let url = "auth/logout";
    let method = "POST";
    let params = {
      email: usersrole.email,
    };
    const response = await fetch(REACT_APP_BASE_URL + url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": "",
      },
      body: JSON.stringify(params),
    });
    const json = await response.json();
    if (json.status == false) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      localStorage.clear();
      window.location.replace("/");
    }
  } catch (Error) {
    console.log("Error", Error);
  }
};
export const GetPublicURL = async(URL) => {
  try {


    let url="access/getpublicurl"
    let method="POST"
    let params ={
      url:URL
    }
    const response = await PostMethod({url,method,params})
    if(response.status){
      return response.result
    }else{
      return ""
    }
  } catch (Error) {
    console.log("Error in GetPublicURL", Error)
    return ""
  }

}